import React, {useCallback, useEffect} from 'react';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import {alpha, useTheme} from '@mui/material/styles';

import Main from '../layouts/Main';
import Container from '../components/Container';
import Header from '../components/landingpageComponents/Header';
import SchnelleReise from '../components/landingpageComponents/SchnelleReise';
import DeineReise from '../components/landingpageComponents/DeineReise';
import Advantages from '../components/landingpageComponents/Advantages';
import Pricing from '../components/landingpageComponents/Pricing';
import HostApplication from '../components/landingpageComponents/HostApplication';
import EarlyAccess from '../components/landingpageComponents/EarlyAccess';
import TeamAndContact from '../components/landingpageComponents/TeamAndContact';
// import Newsletter from '../components/landingpageComponents/Newsletter';
import Testimonials from '../components/landingpageComponents/Testimonials';
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../hooks/hooks";
import { User } from '../services/restserver-openapi';
import {hostAbos, vanliferAbos} from "../constants/constants";
import SubscriptionComparison from "../components/profileComponents/SubscriptionComparison";
import Typography from "@mui/material/Typography";
import {PaletteMode} from "@mui/material";

function LandingPage() {
  const theme = useTheme();
    const mode = theme.palette.mode;
    let navigate = useNavigate();

    const userRoleLogin = useAppSelector((state) => state.login.userRoleLogin);
    const isAuthenticated = useAppSelector((state) => state.login.isAuthenticated);
    const userIsRegistered = useAppSelector((state) => state.login.userIsRegistered);

    const checkRoleOfLogin = useCallback(()=> {
        if (userIsRegistered && userRoleLogin === User.userRole.HOST) {
            navigate("host/HostOverview");
        } else if (userIsRegistered && userRoleLogin === User.userRole.VANLIFER) {
            navigate("vanlifer/TravelPlanning");
        } else if (userIsRegistered && userRoleLogin === User.userRole.AGENT) {
            navigate("travelAgent/AgentUserOverview");
        } else if (!userIsRegistered && isAuthenticated) {
            navigate("RegisterNewUser");
        } else {
            navigate("/");
        }
    }, [userIsRegistered, userRoleLogin, navigate, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            checkRoleOfLogin()
        }
    }, [checkRoleOfLogin, isAuthenticated]);


    return (
    <Main>
      <Header />
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
            <div id={'more-info'}>
                <Advantages />
            </div>
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
          <SchnelleReise />
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
          <Testimonials />
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
          <DeineReise />
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
        <Box bgcolor={'secondary.light'}>
            <Container >
                <EarlyAccess />
            </Container>
        </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
            <Box marginBottom={4}>
                <Typography
                    align={'center'}
                    variant="h3"
                    color="text.primary"
                    sx={{ fontWeight: 700 }}
                >
                    Einfach und Flexibel{' '}
                    {/*<br />*/}
                    <Typography
                        color={'text.primary'}
                        component={'span'}
                        variant={'inherit'}
                        sx={{
                            background: `linear-gradient(180deg, transparent 82%, ${alpha(
                                mode === 'light' as PaletteMode ? theme.palette.secondary.main : theme.palette.primary.main,
                                0.3,
                            )} 0%)`,
                        }}
                    >
                        Mitmachen
                    </Typography>
                </Typography>
                <Typography
                    variant="h6"
                    align={'center'}
                    color={'text.secondary'}
                    data-aos={'fade-up'}
                >
                    Dir gefällt der Reiseplaner und die Open Travel Community? Hier findest Du unsere Mitmach-Optionen.
                </Typography>
                <Typography
                    variant="body1"
                    align={'center'}
                    color={'text.secondary'}
                    data-aos={'fade-up'}
                >
                    Sobald Du Dich registrierst erhältst Du automatisch die kostenlose "Free"-Mitgliedschaft und wirst Teil unserer Open Travel Community. Du sicherst Dir damit dauerhaften Zugriff auf alle Deine Reisen.
                    Mit einer "Early Access"-Mitgliedschaft unterstützt Du unsere Weiterentwicklung mit einem einmaligen Betrag. Als Gegenleistung nutzt und testest Du alle Funktionen und wirst ein wichtiger Teil unseres Entwicklungsteams.
                </Typography>
            </Box>
            <SubscriptionComparison abos={vanliferAbos} />
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
          <TeamAndContact />
        </Container>
      </Box>
      {/*<Divider sx={{marginTop:0, marginBottom:0}}/>*/}
      <Box bgcolor={theme.palette.alternate}>
        <Container>
          <HostApplication />
        </Container>
      </Box>
    </Main>
  );
}

export default LandingPage;
